import React from 'react';
import { createMergingContextProvider } from '@wix/da-react-context/pkg/helpers';
var BiContext = React.createContext({});
BiContext.displayName = 'BiContext';
var BiLoggerContextConsumer = BiContext.Consumer;
/**
 * Merge context for nested providers
 */
var BiLoggerContextProvider = createMergingContextProvider(BiContext, 'BiLoggerContextProvider');
export { BiLoggerContextProvider, BiLoggerContextConsumer, BiContext };
//# sourceMappingURL=BiLogger.context.js.map